import { Routes } from '@angular/router';
import { CustomerVideoHomeComponent } from './pages/customer-video-home/customer-video-home.component';
import { WelcomeHomeComponent } from './pages/welcome-home/welcome-home.component';
import { NoSignInWatchVideoComponent } from './pages/no-signin-watch-video/no-signin-watch-video.component';
import { AuthorizationCallbackComponent } from './pages/authorization-callback/authorization-callback.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', component: WelcomeHomeComponent },
  { path: 'no-signin-watch-video', component: NoSignInWatchVideoComponent },
  { path: 'video', component: CustomerVideoHomeComponent, canActivate: [authGuard] },
  { path: 'authorization/callback', component: AuthorizationCallbackComponent },
  // { path: 'employeewelcome', component: EmployeeVideoHomeComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
